import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Header from 'Components/BetSlip/Header';
import Content from 'Components/BetSlip/Content';
import Footer from 'Components/BetSlip/Footer';
import { classnames } from 'Utils/classnames';
import LocalStorage from 'Utils/localStorage';
import History from 'Store/history';
import Atrium from './Atrium';
import { withMixpanel } from 'Utils/mixpanel';
import Message from 'Components/Modal/Message';

//import { SG_ERROR_TYPE_1 } from 'Store/constants/sportTypes';

import {
  BetslipRecommendedModal,
  PlayFailure,
  SaveFailure,
  SystemCoupons,
  SaveCouponSuccess,
  InsufficientFundsModal,
  SelectSystem,
  CouponPlayWaiting,
  MultiplePlayFailure,
  TribunRouteModal,
  TribunRouteRecommendedModal,
  DeleteCouponPermission,
  SavedCouponName, ClearAndAddModal
} from './Modals';
import { RenderActiveModals } from 'Pages/TribunV2/Modals';

import {
  playCoupon,
  removeEventFromBetSlip,
  toggleBetSlipBanker,
  setBetSlipMultiplier,
  setBetSlipCouponCount,
  setBetSlipSystem,
  validateBetSlip,
  openModal,
  closeModal,
  saveCoupon,
  resetBetSlip,
  getSystemCoupons,
  shareTribunCoupon,
  getUserTribunToken,
  updateUserBalance,
  betSlipOpened,
  betSlipClosed,
  addMultipleEventsToBetSlip,
  createTribunUser,
  getTribunUserAgreement,
  getTribunTermOfUse,
  openDrawer,
  addEventVerifyRecommended
} from 'Store/actions';
import BetslipModal from 'Components/BetslipModal';
import { toast } from 'react-toastify';
import ToastTemplate from 'Components/ToastTemplate';
import BlockUI from 'react-block-ui';
import LottieLoader from 'Components/LottieLoader';
import EnvironmentManager from 'Utils/environmentManager';
import { shouldRefreshBalanceOnBetSlipOpen } from 'Utils/accountBalancePolling';
import BetSlipSettingsContent from './Footer/BetSlipSettingsContent';
import { throttle } from 'lodash';
import axios from 'axios';
import Modal from '../Modal';

class BetSlip extends Component {
  static propTypes = {
    playCoupon: PropTypes.func,
    saveCoupon: PropTypes.func,
    addMultipleEventsToBetSlip: PropTypes.func,
    removeEventFromBetSlip: PropTypes.func,
    toggleBetSlipBanker: PropTypes.func,
    setBetSlipMultiplier: PropTypes.func,
    setBetSlipCouponCount: PropTypes.func,
    setBetSlipSystem: PropTypes.func,
    isOpen: PropTypes.bool,
    auth: PropTypes.object,
    betSlip: PropTypes.object,
    saveCouponStatus: PropTypes.object,
    modalData: PropTypes.object,
    validateBetSlip: PropTypes.func,
    openModal: PropTypes.func,
    closeModal: PropTypes.func,
    playCouponState: PropTypes.object,
    resetBetSlip: PropTypes.func,
    eventScores: PropTypes.object,
    getSystemCoupons: PropTypes.func,
    updateUserBalance: PropTypes.func,
    shareTribunCoupon: PropTypes.func,
    getUserTribunToken: PropTypes.func,
    tribun: PropTypes.object,
    isBetSlipHidden: PropTypes.bool,
    betSlipOpened: PropTypes.func,
    betSlipClosed: PropTypes.func,
    registeredCampaigns: PropTypes.object,
    createTribunUser: PropTypes.func,
    userAgent: PropTypes.object,
    getTribunUserAgreement: PropTypes.func,
    getTribunTermOfUse: PropTypes.func,
    openDrawer: PropTypes.func,
    tribunUserAgreement: PropTypes.object,
    tribunTermOfUse: PropTypes.object,
    mixpanel: PropTypes.object
  };

  constructor (props) {
    super(props);
    this.state = {
      showDeletedBackMatchToast: false,
      deletedMatchToastKey: 0,
      systemModalClosable: true,
      isPrimaryButtonDisabled: false,
      isOpen: false,
      message: '',
      name: '',
      error: '',
      addDescriptionCouponFail: {
        icon: null,
        type: null,
        title: null
      }
    };
    this.pendingSaveCouponMixpanel = false;
    this.scrollPosition = 0;
  }

  componentDidMount () {
    //TODO: Move this logic to actions and reducers and rename "opened" actions to openBetSlip
    this.unListen = History.listen((location, action) => {
      this.setState({
        isOpen: false
      });

      if (action === 'POP') {
        this.setState({
          isOpen: LocalStorage.get('betSlipOpened')
        }, () => LocalStorage.remove('betSlipOpened'));
      }

    });

    const isOpen = LocalStorage.get('betSlipToggler');
    if (isOpen) {
      this.setState({
        isOpen
      });
      this.props.betSlipOpened();
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const { betSlip } = this.props;

    if (prevState.isOpen !== this.state.isOpen) {
      const isMobile = !(this?.props?.userAgent?.device?.type === 'desktop');

      if (this.state.isOpen) {

        const hasEventsInBetSlip = !!betSlip.coupon.bets.length;

        if (hasEventsInBetSlip && betSlip.isMBSValid) {
          this.props.validateBetSlip();
        }

        // iOS Safari için body scroll lock
        if (isMobile) {
          this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
          document.body.style.position = 'fixed';
          document.body.style.top = `-${this.scrollPosition}px`;
          document.body.style.width = '100%';
        }
      } else {
        // Body scroll lock'u kaldır ve scroll pozisyonunu geri yükle
        if (isMobile) {
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.width = '';
          window.scrollTo(0, this.scrollPosition);
        }
      }
    }

    // TODO: acilip-kapanma logici reduxa tasindiginda burayi sil
    if (prevProps.betSlip.isOpen !== this.props.betSlip.isOpen) {
      if (this.props.betSlip.isOpen && !!betSlip.coupon.bets.length) {
        this.setState({ isOpen: true });
      }
    }

    if (this.state.isOpen && prevProps.betSlip.coupon.bets.length === 1 && this.props.betSlip.coupon.bets.length === 0) {
      this.props.resetBetSlip();
      const isMobile = !(this?.props?.userAgent?.device?.type === 'desktop');
      if (isMobile) {
        this.setState({ isOpen: false }, () => {
          LocalStorage.set('betSlipToggler', false);
          this.props.betSlipClosed();
        });
      }
    }

    const saveCouponRequestFinishedSuccessfully
      = prevProps.saveCouponStatus?.isLoading
      && !this.props.saveCouponStatus?.isLoading
      && !this.props.saveCouponStatus?.error;

    if (this.pendingSaveCouponMixpanel && saveCouponRequestFinishedSuccessfully) {
      const betTypeList = (this.props.betSlip?.coupon?.bets || []).map(bet => bet?.isLive ? 'Canlı' : 'İddaa');

      this.props.mixpanel.track('Click Save Button İddaa Betslip', {
        'Bet Type': betTypeList
      });

      this.pendingSaveCouponMixpanel = false;
    }

    if (this.pendingSaveCouponMixpanel && !this.props.saveCouponStatus?.isLoading && this.props.saveCouponStatus?.error) {
      this.pendingSaveCouponMixpanel = false;
    }
  }

  _removeFromBetSlip = (() => {
    let timeoutId = null;
    return throttle(oddId => {
      const animationDurationSec = parseFloat(EnvironmentManager.getMessageText({ key: 'undo_on_betslip_display_time' }));
      const animationDurationMs = animationDurationSec * 1000;
      this.props.removeEventFromBetSlip(oddId);

      this.setState(prevState => ({
        showDeletedBackMatchToast: true,
        deletedMatchToastKey: prevState.deletedMatchToastKey + 1
      }));

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = setTimeout(() => {
        this.setState({ showDeletedBackMatchToast: false });
      }, animationDurationMs + 500);
    }, 1000);
  })();

  handleSystemModalClosable = systemModalClosable => {
    this.setState({
      systemModalClosable
    });
  };

  handleSystemSelection = selectedSystems => {
    this.props.setBetSlipSystem(selectedSystems);
  };

  handlePlayCoupon = () => {
    const { auth, betSlip } = this.props;
    const { isAuthenticated } = auth;

    if (isAuthenticated) {

      if (!betSlip.isMBSValid) {
        return toast(
          <ToastTemplate type="error">
            MBS kuralı nedeniyle kuponuna maç eklemeye devam etmelisin.
          </ToastTemplate>,
          {
            toastId: 'betSlipMbsToast'
          }
        );
      }

      this.props.playCoupon();
    } else {
      toast.dismiss('betSlipMbsToast');
      History.push('/giris-yap');
    }
  };

  isModalOpen = modalNameRequest => {
    const { modalNames } = this.props.modalData;
    return modalNames.some(modalName => modalName === modalNameRequest);
  };

  onChange = e => {
    this.setState({
      name: e.target.value,
    });
  }

  clearInput = fieldName => {
    this.setState({
      [fieldName]: '',
      name: ''
    });
  }

  saveCouponName = () => {
    if (this.state.name !== '' && this.state.name.length < 3) {
      this.setState({
        error: EnvironmentManager.getMessageText({ key: 'error_coupon_saved_naming_desc' }) || 'Kuponun ismi en az 3 karakter olmalıdır.',
      });
    } else {
      this.props.closeModal('savedCouponNameModal');
      this.props.betSlip.coupon.couponName = this.state.name;
      this.pendingSaveCouponMixpanel = true;
      this.props.saveCoupon();
      this.setState({
        error: '',
        name: ''
      });
    }
  };
  closeCouponNamedModal = () => {
    this.props.closeModal('savedCouponNameModal');
    this.setState({
      error: '',
      name: ''
    });
  }


  getActiveModalContent = () => {
    const { systemModalClosable, name } = this.state;
    const { betSlip, playCouponState, saveCouponStatus } = this.props;

    if (this.isModalOpen('couponPlayLoader')) {
      return (
        <BetslipModal
          className="modal--coupon-playing"
          title="Kuponun Oynanıyor"
          showClose={ false }
          overlayClick={ false }
          position={ { web: 'center' } }
          closeIconVisible={ false }
          disableOverlayClick={ true }
        >
          <LottieLoader type="loading" loop={ true } autoplay width="38px" />
        </BetslipModal>
      );
    }

    if (this.isModalOpen('couponPlayWaiting')) {
      return (
        <BetslipModal
          title={ EnvironmentManager.getMessageText({ key: 'error_betslip_coupon_waiting_title' }) || 'Onay Bekleniyor' }
          iconName='svgHourglassOrange'
          type='waiting'
          onClose={ () => this.props.closeModal('couponPlayWaiting') }
          position={ { web: 'center' } }
        >
          <CouponPlayWaiting
            onPrimaryButtonClick={ () => {
              this.props.closeModal('couponPlayWaiting');
              this.toggleBetSlip('/kuponlarim/iddaa/devam-eden', playCouponState?.data?.coupon?.bets?.some(bet => bet.outright));
            } }
            message={ EnvironmentManager.getMessageText({ key: 'error_betslip_play_timeout' }) }
          />
        </BetslipModal>
      );
    }

    if (this.isModalOpen('saveCouponSuccessModal')) {
      const routePath = '/kuponlarim/iddaa/kayitli';

      return (
        <BetslipModal
          position={ { web: 'center' } }
          onClose={ () => this.props.closeModal('saveCouponSuccessModal') }>
          <SaveCouponSuccess
            onPrimaryButtonClick={ () => {
              this.props.closeModal('saveCouponSuccessModal');
              this.toggleBetSlip('/iddaa');
            } }
            onSecondaryButtonClick={ () => {
              this.props.closeModal('saveCouponSuccessModal');
              this.toggleBetSlip(routePath, this.props?.modalData?.saveCouponSuccessModal?.isLongTermCoupon);
            } }
          />
        </BetslipModal>
      );
    }

    if (this.isModalOpen('savedCouponNameModal')) {

      return (
        <BetslipModal
          position={ { web: 'center' } }
          onClose={ () => this.closeCouponNamedModal() }>
          <SavedCouponName
            onPrimaryButtonClick={ () => {
              this.saveCouponName();
            } }
            onSecondaryButtonClick={ () => {
              this.closeCouponNamedModal();
            } }
            onChange={ this.onChange }
            clearInput={ this.clearInput }
            error={ this.state.error }
            name={ name }
          />
        </BetslipModal>
      );
    }

    if (this.isModalOpen('systemCouponsModal')) {
      return (
        <BetslipModal
          contentClass="modal__content--transparent"
          position={ { web: 'center' } }
          onClose={ () => this.props.closeModal('systemCouponsModal') }>
          <SystemCoupons />
        </BetslipModal>
      );
    }

    if (this.isModalOpen('clearAndModal')) {
      return (
        <Modal
          iconName="svgNewPlus"
          onClose={ () => this.props.closeModal('clearAndModal') }
          buttonArea={ {
            primaryButton: {
              onClick: ()=> {
                this.props.closeModal('clearAndModal');
              },
              label: EnvironmentManager.getMessageText({ key: 'tribun_clean_add' }),
            }
          } }
        >
          <ClearAndAddModal/>
        </Modal>
      );
    }

    if (this.isModalOpen('recommendedWarningModal')) {
      const data = this.props?.modalData.recommendedWarningModal;
      const profBahistaHeader = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_info_header' });
      const profBahistaText = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_info_text' });
      const profOkey = EnvironmentManager.getMessageText({ key: 'button_okay_lc' }) || 'TAMAM';

      const postData = {
        infoPopUpShown: true
      };

      const buttonConfig = {
        primary: {
          label: profOkey,
          onClick: () => {
            data?.nextModal();
            this.props.mixpanel.track('View Info Pop-up Recomended');
            // eslint-disable-next-line no-undef
            axios.post(`${API_GATEWAY}/user-settings/info-pop-up`, postData)
              .then(({ data }) => this.props.closeModal('recommendedWarningModal'))
              .catch(console.error);
          }
        }
      };

      return (
        <BetslipModal
          iconName='svgInfoGreen'
          position={ { web: 'center' } }
          title={ profBahistaHeader }
          onClose={ async () => {
            if (!systemModalClosable) return;
            this.props.mixpanel.track('View Info Pop-up Recomended');
            try {
              data?.nextModal();
              // eslint-disable-next-line no-undef
              await axios.post(`${API_GATEWAY}/user-settings/info-pop-up`, postData);

              this.props.closeModal('recommendedWarningModal');
            } catch (error) {
              console.error('Error closing the modal or posting data:', error);
            }
          } } >

          <Message type='none' buttonConfig={ buttonConfig }>
            <p>{ profBahistaText }</p>
          </Message>

        </BetslipModal>
      );
    }

    if (this.isModalOpen('playCouponFailureModal')) {
      const title = EnvironmentManager.getMessageText({ key: 'title-iddaa-coupons-api35122' }) || 'Spor Toto Oynatmadı';
      return (
        <BetslipModal
          iconName="svgPlayFailure"
          title={ playCouponState.error.code === 35122 ? title : 'Kuponun oynanamadı' }
          type="error"
          position={ { web: 'center' } }
          onClose={ () => this.props.closeModal('playCouponFailureModal') }
        >
          <PlayFailure
            playCouponError={ playCouponState.error }
            onPrimaryButtonClick={ () => {
              this.props.closeModal('playCouponFailureModal');
              History.push('/kuponlarim/iddaa/devam-eden');
              /*if (SG_ERROR_TYPE_1.includes(`${playCouponState.error.domain}${playCouponState.error.code}`)) {
                History.push('kuponlarim/iddaa/devam-eden');
              } else {
                this.handlePlayCoupon();
              }*/
            } }
            onSecondaryButtonClick={ () => {
              this.props.closeModal('playCouponFailureModal');
              this.props.betSlipOpened();
              this.props.openDrawer({
                isOpen: true,
                content: <BetSlipSettingsContent />,
                container: document.getElementsByClassName('betslip')[0],
                position: { web: 'bottom', mobile: 'bottom' },
              });
            } }
          />
        </BetslipModal>
      );
    }

    if (this.isModalOpen('saveCouponFailureModal')) {
      return (
        <BetslipModal
          iconName="svgPlayFailure"
          title="Kuponun kaydedilemedi"
          type="error"
          position={ { web: 'center' } }
          onClose={ () => this.props.closeModal('saveCouponFailureModal') }
        >
          <SaveFailure
            saveCouponError={ saveCouponStatus.error }
            onPrimaryButtonClick={ () => {
              this.props.closeModal('saveCouponFailureModal');
              History.push('/kuponlarim/iddaa/kayitli');
            } }
          />
        </BetslipModal>
      );
    }

    if (this.isModalOpen('playMultipleCouponFailureModal')) {
      return (
        <BetslipModal
          iconName="svgInfoRed"
          title={ EnvironmentManager.getMessageText({ key: 'error_betslip_coupon' }) || 'Kuponların Oynanamadı' }
          type="error"
          position={ { web: 'center' } }
          onClose={ () => this.props.closeModal('playMultipleCouponFailureModal') }
        >
          <MultiplePlayFailure
            couponCount={ betSlip.coupon.couponCount }
            onPrimaryButtonClick={ () => {
              this.props.closeModal('playMultipleCouponFailureModal');
              this.toggleBetSlip('/iddaa');
            } }
          />
        </BetslipModal>
      );
    }

    if (this.isModalOpen('insufficientFundsModal')) {
      return (
        <InsufficientFundsModal
          onClose={ () => this.props.closeModal('insufficientFundsModal') }
          onSaveCoupon={ this.props.saveCoupon }
          onDepositClick={ () => History.push('/hesabim/para-yatir') }
          gameType="iddaa"
        />
      );
    }

    if (this.isModalOpen('selectSystemModal')) {
      const { data, isLoading } = betSlip.validateData;
      return (
        <BetslipModal
          position={ { web: 'center' } }
          onClose={ () => systemModalClosable ? this.props.closeModal('selectSystemModal') : null }>
          <SelectSystem
            betSlip={ betSlip }
            availableSystems={ data.availableSystems }
            activeSystems={ betSlip.coupon.system }
            isLoading={ isLoading }
            validateBetSlip={ validateBetSlip }
            columnCount={ data.columnCount }
            closeModal={ this.props.closeModal }
            handleSystemModalClosable={ this.handleSystemModalClosable }
            handleSystemSelection={ selectedSystems => this.handleSystemSelection(selectedSystems) }
          />
        </BetslipModal>
      );
    }

    if (this.isModalOpen('betSlipLabelInfoModal')) {
      const title_multi_coupon_info = EnvironmentManager.getMessageText({ key: 'title_multi_coupon_info' })  || 'Çoklu Kupon Oynama';
      const description_multi_coupon_info = EnvironmentManager.getMessageText({ key: 'description_multi_coupon_info' })  || 'Çoklu Kupon Seçebilmek için Kupon Bedeli 500 TL ve üzeri olmalıdır.';
      const button_multi_coupon_info = EnvironmentManager.getMessageText({ key: 'button_multi_coupon_info' }) || 'ANLADIM';

      const buttonConfig = {
        primary: {
          label: button_multi_coupon_info,
          onClick: () => {
            this.props.closeModal('betSlipLabelInfoModal');
          }
        }
      };

      return (
        <BetslipModal
          iconName='svgInfoFilled'
          position={ { web: 'center' } }
          title={ title_multi_coupon_info }
          onClose={ () => systemModalClosable ? this.props.closeModal('betSlipLabelInfoModal') : null } >

          <Message type='none' buttonConfig={ buttonConfig }>
            <p>{ description_multi_coupon_info }</p>
          </Message>

        </BetslipModal>
      );
    }

    if (this.isModalOpen('tribunRouteRecommendedModal')) {
      const recommendedToastMessage = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_toast_message' });
      const { title, icon } = this.state.addDescriptionCouponFail;

      return (
        <BetslipRecommendedModal
          type={ 'success' }
          title={ title || 'Kuponun Başarı ile Oynandı' }
          iconName={ icon || 'svgCircleCheck' }
          position={ { web: 'center' } }
          onClose={ () => {
            // this.props.resetBetSlip();
            this.props.closeModal('tribunRouteRecommendedModal');
            if (!this?.props?.betSlip?.validateData?.data?.isRecommendedValid) {
              this.props.resetBetSlip();
              LocalStorage.get('betSlipToggler') && this.toggleBetSlip();
              return toast(
                <ToastTemplate type="error">
                  { recommendedToastMessage }
                </ToastTemplate>,
                {
                  toastId: 'betSlipRecommendedToast'
                }
              );
            }
          } }
        >
          <TribunRouteRecommendedModal
            data={ this.props }
            couponDetails={ betSlip.couponDetails }
            playCouponState={ playCouponState?.data }
            onPrimaryButtonClick={ () => {
              this.props.closeModal('tribunRouteRecommendedModal');
              LocalStorage.get('betSlipToggler') && this.toggleBetSlip();
            } }
            onSecondaryButtonClick={ () => {
              this.props.closeModal('tribunRouteRecommendedModal');
              // eslint-disable-next-line react/prop-types
              this.props.addEventVerifyRecommended({ eventId: playCouponState?.data?.recommendedData?.eventId,
                event: playCouponState?.data?.recommendedData?.recommendedCouponDetail, recommendedCost: playCouponState?.data?.recommendedData?.recommendedCouponDetail?.cost  });
            } }
          />
        </BetslipRecommendedModal>
      );
    }
    if (this.isModalOpen('tribunRouteModal')) {
      const routePath = '/kuponlarim/iddaa/devam-eden';

      return (
        <BetslipModal
          iconName='svgModalSuccess'
          title="Kuponunuz Tribün'de paylaşıldı."
          position={ { web: 'center' } }
          onClose={ () => {

            this.props.resetBetSlip();
            this.props.closeModal('tribunRouteModal');
            LocalStorage.get('betSlipToggler') && this.toggleBetSlip();
          } }
        >
          <TribunRouteModal
            onPrimaryButtonClick={ () => {
              this.props.resetBetSlip();
              this.props.closeModal('tribunRouteModal');
              History.push(routePath, { isLongTermCoupon: this.props?.modalData?.tribunRouteModal?.isLongTermCoupon });
            } }
            onSecondaryButtonClick={ () => {
              this.props.resetBetSlip();
              this.props.closeModal('tribunRouteModal');
              History.push('/tribun/lider-100');
            } }
          />
        </BetslipModal>
      );
    }
    if (this.isModalOpen('deleteCouponPermissionModal')) {
      return (
        <BetslipModal
          iconName="svgInfoFilled"
          contentClass= "modal--error"
          position={ { web: 'center' } }
          title={ EnvironmentManager.getMessageText({ key: 'betslip_delete_head_message' }) }
          onClose={ () => {
            this.props.closeModal('deleteCouponPermissionModal');
          } }
        >
          <DeleteCouponPermission
            onPrimaryButtonClick={ () => {
              this.props.closeModal('deleteCouponPermissionModal');
              this.props.resetBetSlip();
              this.toggleBetSlip();
            } }
            onSecondaryButtonClick={ () => this.props.closeModal('deleteCouponPermissionModal') }
          />
        </BetslipModal>
      );
    }
  };

  toggleBetSlip = (redirectUrl, isLongTermCoupon) => {
    const type = redirectUrl?.type;

    this.setState(prevState => (
      { isOpen: !prevState.isOpen }
    ), () => {
      LocalStorage.set('betSlipToggler', this.state.isOpen);
      LocalStorage.set('betSlipTogglerWithClick', type);
      if (this.state.isOpen) {
        this.props.betSlipOpened();
      } else {
        this.props.betSlipClosed();
      }

      if (typeof redirectUrl === 'string') {
        if (isLongTermCoupon)
          History.push(redirectUrl, { isLongTermCoupon: isLongTermCoupon });
        else
          History.push(redirectUrl);
      }
      if (this.state.isOpen && shouldRefreshBalanceOnBetSlipOpen({
        isAuthenticated: this.props.auth.isAuthenticated,
        isBalanceSSEEnabled: EnvironmentManager.getParameter('user_sse_enabled_web') === true
      })) {
        this.props.updateUserBalance();
      }
    }
    );
  };

  componentWillUnmount () {
    if (this.unListen) {
      this.unListen();
    }
  }

  render () {
    const { auth, betSlip, eventScores, isBetSlipHidden, registeredCampaigns } = this.props;
    const { validateData: { data: validatedCoupon } } = betSlip;
    const isFooterVisible = !!betSlip.coupon.bets.length;

    // Supersystem disabled..
    const isVisibleSuperSystemButton = false;
    // const hasLiveBet = betSlip.coupon.bets.length && betSlip.coupon.bets.some(bet => bet.isLive);
    // const isVisibleSuperSystemButton = validatedCoupon.canPlaySuperSystem && validatedCoupon.columnCount > 1 && validatedCoupon.columnCount < 100
    //   && !hasLiveBet;

    const isCampaignActive = EnvironmentManager.getParameter('campaign_info_visible');
    const campaignId = EnvironmentManager.getParameter('active_withdraw_campaignId');
    const showCampaignMessage = isCampaignActive && registeredCampaigns[campaignId];

    const betSlipClassname = classnames({
      betslip: true,
      'betslip--active': this.state.isOpen && !isBetSlipHidden,
      'betslip--invalid': !betSlip.isMBSValid || !betSlip.isMBSCombinationValid,
      'betslip--empty': !isFooterVisible,
      'betslip--super-system': isVisibleSuperSystemButton,
      'betslip--forced-mobile': !(this?.props?.userAgent?.device?.type === 'desktop')
    });

    const renderModalContent = this.getActiveModalContent();

    return (
      <>
        <Atrium betSlip={ betSlip } isDesktop={ this?.props?.userAgent?.device?.type === 'desktop' } onClick={ this.toggleBetSlip } />
        <div className={ betSlipClassname }>
          <BlockUI
            tag="div"
            className="block-ui--relative block-ui--theme-dark block-ui--100percent"
            blocking={ betSlip.validateData.isLoading && !this.isModalOpen('selectSystemModal') }
            loader={ <LottieLoader type="loading" loop={ true } autoplay width="75px" /> }
            renderChildren={ true }
          >
            <Header
              bets={ betSlip.coupon.bets }
              toggleBetSlip={ this.toggleBetSlip }
              openModal={ this.props.openModal }
              isMBSValid={ betSlip.isMBSValid }
              auth={ auth }
              saveCoupon={ this.props.saveCoupon }
              isMBSCombinationValid={ betSlip.isMBSCombinationValid }
              coupon={ betSlip.coupon }
            />

            <Content
              betSlipData={ betSlip }
              showDeletedBackMatchToast = { this.state.showDeletedBackMatchToast }
              deletedMatchToastKey={ this.state.deletedMatchToastKey }
              onRemoveClick={ this._removeFromBetSlip }
              toggleBetSlip={ this.toggleBetSlip }
              toggleBetSlipBanker={ this.props.toggleBetSlipBanker }
              eventScores={ eventScores }
              showCampaignMessage={ showCampaignMessage }
              isMBSValid={ betSlip.isMBSValid }
              betSlipClose={ this.props.betSlipClosed }
            />
            {
              isFooterVisible
              && <Footer
                coupon={ betSlip.coupon }
                isMBSValid={ betSlip.isMBSValid }
                isMBSCombinationValid={ betSlip.isMBSCombinationValid }
                validatedCoupon={ validatedCoupon }
                onPlayClick={ this.handlePlayCoupon }
                isPlaying={ this.isModalOpen('couponPlayLoader') }
                setBetSlipMultiplier={ this.props.setBetSlipMultiplier }
                setBetSlipCouponCount={ this.props.setBetSlipCouponCount }
                toggleBetSlip={ this.toggleBetSlip }
                isVisibleSuperSystemButton={ isVisibleSuperSystemButton }
                openModal={ this.props.openModal }
                getSystemCoupons={ this.props.getSystemCoupons }
                userAgent={ this.props.userAgent }
                saveCoupon={ this.props.saveCoupon }
                auth={ auth }
                betSlipData={ betSlip }
              />
            }

            { renderModalContent }
            <RenderActiveModals
              modalData={ this.props.modalData }
              isModalOpen={ this.isModalOpen }
              closeModal={ this.props.closeModal }
              openModal={ this.props.openModal }
              addMultipleEventsToBetSlip={ this.props.addMultipleEventsToBetSlip }
              createTribunUser={ this.props.createTribunUser }
              getTribunUserAgreement={ this.props.getTribunUserAgreement }
              getTribunTermOfUse={ this.props.getTribunTermOfUse }
              tribunUserAgreement={ this.props.tribunUserAgreement }
              tribunTermOfUse={ this.props.tribunTermOfUse }
            />
          </BlockUI>
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  betSlip: state.betSlip,
  modalData: state.modalData,
  auth: state.auth,
  playCouponState: state.playCoupon,
  saveCouponStatus: state.saveCouponStatus,
  eventScores: state.eventScores,
  tribun: state.tribun,
  registeredCampaigns: state.membership.registeredCampaigns.data,
  isLongTermCoupon: PropTypes.bool,
  tribunUserAgreement: state.tribun.tribunUserAgreement,
  tribunTermOfUse: state.tribun.tribunTermOfUse
});

export default connect(
  mapStateToProps,
  {
    playCoupon,
    removeEventFromBetSlip,
    addMultipleEventsToBetSlip,
    setBetSlipMultiplier,
    setBetSlipCouponCount,
    setBetSlipSystem,
    validateBetSlip,
    toggleBetSlipBanker,
    openModal,
    closeModal,
    saveCoupon,
    resetBetSlip,
    getSystemCoupons,
    updateUserBalance,
    shareTribunCoupon,
    getUserTribunToken,
    betSlipOpened,
    betSlipClosed,
    createTribunUser,
    getTribunUserAgreement,
    getTribunTermOfUse,
    openDrawer,
    addEventVerifyRecommended
  }
)(withMixpanel(BetSlip));
